import { render, staticRenderFns } from "./liveStatus.vue?vue&type=template&id=03123002&scoped=true&"
import script from "./liveStatus.vue?vue&type=script&lang=js&"
export * from "./liveStatus.vue?vue&type=script&lang=js&"
import style0 from "./liveStatus.vue?vue&type=style&index=0&id=03123002&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03123002",
  null
  
)

export default component.exports